module.exports = __webpack_public_path__ + "staticcomp/img/marquee.e6e55a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/17/marquee.jpg
// module id = S+wD
// module chunks = 39